import { Card } from "primereact/card";
import React from "react";
import DeservantData from "./deservantData";

const TarbiyahProgramDetail = (props) => {

  return (
    <React.Fragment>
      <div style={{ padding: "1rem" }}>
        <div className="mb-4">
          <Card>
            <div className="flex align-items-center">
              <h5 className="m-0 mr-3"><b>Lecturers:</b></h5>
              <div className="flex flex-wrap gap-2">
                {props.location.state.programs.lecturers.map((lecturer) => {
                  return (
                    <span
                      key={lecturer.id}
                      className="p-2 border-round bg-primary-reverse font-bold"
                      style={{ border: '1px solid #dee2e6' }}
                    >
                      {lecturer.userId.name}
                    </span>
                  );
                })}
              </div>
            </div>
          </Card>
        </div>

        <div style={{ width: "100%" }}>
          <h4 className="mb-3">Attendees Details</h4>
          <DeservantData program={props.location.state.programs} />
        </div>
      </div>
    </React.Fragment>
  );
};
export default TarbiyahProgramDetail;
